export default {
  name: 'Render',
  functional: true,
  props: {
    render: Function,
    others: Array
  },
  render: (h, ctx) => ctx.props.render(h, ...ctx.props.others)
}